import React from 'react';
import Loader from '@/components/Routes/Loader';
import loadable from '@loadable/component';
import { FC } from 'react';

const BetsApprovalHistoryList = loadable(
  () => import('@/features/betApprovals/pages/BetApprovals/tabs/History'),
  { fallback: <Loader /> }
) as FC;

export { BetsApprovalHistoryList };
